import {
  TOGGLE_POPIN_APPOINTMENT,
  SUBMIT_POPIN_APPOINTMENT,
  FETCH_MOTIVES,
  TOGGLE_POPIN_SHARE,
  SUBMIT_POPIN_SHARE,
  TOGGLE_POPIN_NEWSLETTER,
  SUBMIT_POPIN_NEWSLETTER,
} from '../actions/popin';

const initialState = {
  isPopinAppointmentOpen: false,
  isPopinShareOpen: false,
  isPopinNewsletterOpen: false,
  newsletterEmail: null,
  motives: [],
  confirmation: null
};

export function popin(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_POPIN_APPOINTMENT:
      return {
        ...state,
        isPopinAppointmentOpen: action.data,
        confirmation: action.data ? state.confirmation : null
      };

    case SUBMIT_POPIN_APPOINTMENT:
      return {
        ...state,
        confirmation: action.confirmation
      };

    case FETCH_MOTIVES:
      return {
        ...state,
        motives: action.data.Items
      };

    case TOGGLE_POPIN_SHARE:
      return {
        ...state,
        isPopinShareOpen: action.data,
        confirmation: action.data ? state.confirmation : null
      };

    case SUBMIT_POPIN_SHARE:
      return {
        ...state,
        confirmation: action.confirmation
      };

    case TOGGLE_POPIN_NEWSLETTER:
      return {
        ...state,
        isPopinNewsletterOpen: action.isOpen,
        confirmation: action.isOpen ? state.confirmation : null,
        newsletterEmail: action.isOpen ? action.email : null
      };

    case SUBMIT_POPIN_NEWSLETTER:
      return {
        ...state,
        confirmation: action.confirmation
      };

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/popin.js